import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Skeleton;
var _excluded = ["children"];
import * as React from 'react';
import { Skeleton, Stack } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ListAvailabilities(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 3,
    children: [_Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      width: "240px",
      height: "42px"
    })), /*#__PURE__*/_jsx(Stack, _extends({
      gap: 3
    }, rest, {
      children: children
    }))]
  });
}